import Cookies from 'js-cookie';

// Cookie configuration
const COOKIE_CONFIG = {
  expires: 7, // 7 days
  secure: process.env.NODE_ENV === 'production',
  sameSite: 'strict'
};

// Token management functions
export const setTokenCookie = (token) => {
  if (token) {
    Cookies.set('token', token, COOKIE_CONFIG);
  }
};

export const getTokenCookie = () => {
  return Cookies.get('token');
};

export const removeTokenCookie = () => {
  Cookies.remove('token');
};

// Other user data cookie functions
export const setUserCookie = (key, value) => {
  if (value !== undefined && value !== null) {
    Cookies.set(key, value, COOKIE_CONFIG);
  }
};

export const getUserCookie = (key) => {
  return Cookies.get(key);
};

export const removeUserCookie = (key) => {
  Cookies.remove(key);
};

// Helper function to get token from cookies only
export const getToken = () => {
  return getTokenCookie();
};

// Helper function to set token in cookies only
export const setToken = (token) => {
  setTokenCookie(token);
};
